import React, { useEffect } from "react";
import { LocalizationProvider } from "./components/templateComponent/core/localization-provider";
import { ThemeProvider } from "./components/templateComponent/core/theme-provider";
import { getMuiLocale } from "./i18n";
import { Provider } from "react-redux";
import StoreManager from "./redux/index";
import { RootMessageBoxProvider, MessageBoxInitializer } from "./components/ui/MessageBox";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";
import "./styles/global.css";
import DefaultScreen from "./screens/DefaultScreen.jsx";
import { Toaster } from "@/components/core/toaster";
import BackgroundTaskService from "./services/BackgroundTaskService";
import AppConfig from "./config/AppConfig";
import DomainMigrationService from "./services/DomainMigrationService";

// Start background tasks and domain migration service
function App() {
    useEffect(() => {
        // Initialize domain migration service for URL handling
        DomainMigrationService.initialize();
        
        // Start background task service
        BackgroundTaskService.startProcessing();
        
        return () => {
            BackgroundTaskService.stopProcessing();
        };
    }, []);

    const mUILocale = getMuiLocale();

    // Determine basename based on subdomain mode
    // In subdomain mode: hust.imleagues.com/rec/admin -> basename="/rec/", route="/admin"
    // In legacy mode: www.imleagues.com/rec/hust/admin -> basename="/rec/", route="/hust/admin"  
    const basename = AppConfig.PUBLIC_PREFIX;

    return (
        <HelmetProvider>
            <LocalizationProvider>
                <RootMessageBoxProvider>
                    <Provider store={StoreManager.getStore()}>
                        <ThemeProvider locale={mUILocale}>
                            <Router basename={basename}>
                                <DefaultScreen />
                            </Router>
                            <MessageBoxInitializer />
                            {/* Root element for StaticModal dialogs */}
                            <div id="static-modal-root" />
                            <Toaster position="bottom-right" />
                        </ThemeProvider>
                    </Provider>
                </RootMessageBoxProvider>
            </LocalizationProvider>
        </HelmetProvider>
    );
}

export default App;
